import axios from "../axios"
import toastService from "./toastService"
import { actions as authActions } from "../store/auth/auth.reducers"
import store from "../store/store"

export const fetchUserData = () => {
  return axios
    .get("/auth/user")
    .then((response) => {
      store.dispatch(authActions.loginUser(response))
      localStorage.setItem("user", JSON.stringify(response || {}))
      return response
    })
    .catch((err) => {
      toastService.error(err.response?.data?.message || err.message)
      throw err
    })
}

export const isUserDataExists = () => localStorage.getItem("user")
